import {sprinkles} from '#style/sprinkles';

import CTASubscription from './CTASubscription/CTASubscription';
import InfoBoxes from './InfoBoxes/InfoBoxes';
import RecentOrders from './RecentOrders/RecentOrders';
import UpcomingOrder from './UpcomingOrder/UpcomingOrder';

const SubscriptionTab = () => {
  return (
    <div className={sprinkles({flex: 'flex', dir: 'col', gap: 20})}>
      <CTASubscription />
      <InfoBoxes />
      <UpcomingOrder />
      <RecentOrders />
    </div>
  );
};

export default SubscriptionTab;
